module.exports = __webpack_public_path__ + "static/media/paste-icon.15e9d541.svg";